import { Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { WszystkieSubskrypcje } from '../models/wszystkie-subskrypcje.model';
import { EformsService } from './eforms.service';
import {Zdarzenie} from '../models/zdarzenie.model';
import { Konfiguracja } from '../models/konfiguracja.model';
import { DateHelper } from '../helpers/dateHelper';
import { DataFilterZdarzeniaService } from './data-filter-zdarzenia.service';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NewsletterService {
  loading$ = new BehaviorSubject<boolean>(false);
  subskrypcjeUzytkownika$ = new BehaviorSubject<WszystkieSubskrypcje[]>([]);
  private idSubskrypcjiZdarzenaWczesniejsze: string;
  zdarzenaWczesniejsze$ =  new BehaviorSubject<Zdarzenie[]>([]);
  konfiguracja$ = new BehaviorSubject<Konfiguracja>(null);
  selectedTabIndex$ = new BehaviorSubject<number>(0);

  constructor(
    private eformsService: EformsService,
    public dataFilterService: DataFilterZdarzeniaService
  ) {}

  initKonfiguracja() {
    this.eformsService.pobierzKonfiguracje().subscribe(konfiguracja => {
      konfiguracja.dataUdostepnienia = DateHelper.formatDate(DateHelper.normalizeDateYYYYMMDD(konfiguracja.dataUdostepnienia), DateHelper.FORMAT_DATE)
      this.konfiguracja$.next(konfiguracja);
    });
  }

  initSubskrypcje(): void {
    this.eformsService
      .pobierzSubskrypcje()
      .subscribe((subskrypcje) => {
        this.subskrypcjeUzytkownika$.next(subskrypcje);
      });
  }

  initZdarzenaWczesniejsze(idSubskrypcji: string): void {
    if(idSubskrypcji === this.idSubskrypcjiZdarzenaWczesniejsze) {
      this.zdarzenaWczesniejsze$.next(this.zdarzenaWczesniejsze$.getValue());
      this.dataFilterService.loading$.next(false);
    } else {
      this.eformsService.pobierzZdarzenaWczesniejsze(idSubskrypcji)
      .pipe(
        catchError(() => {
          this.dataFilterService.loading$.next(false);
          return of(null);
        })
      )
      .subscribe( response => {
        this.idSubskrypcjiZdarzenaWczesniejsze = idSubskrypcji;
        this.zdarzenaWczesniejsze$.next(response);
        this.dataFilterService.loading$.next(false);
      });
    }
  }
}
